<template>
  <div class="bgf5">
    <iHeader />
    <iNav />
    <iClassify :active="8" AllActive />
    <iRightFixedBox />
    <iPageTitle :text="pageTitle" />
    <div class="searchBox">
      <van-field v-model="formData.keyword" center placeholder="搜索当前列表产品">
        <template #button>
          <van-button size="small" type="primary" @click.stop="loadData()">
            <van-icon :name="require('../../assets/search-icon.png')" size="26px" style="line-height:1" />
          </van-button>
        </template>
      </van-field>
    </div>
    <div class="list">
      <div class="goods-box">
        <div class="goods-item"  v-for="goods in dataList" :key="goods.Id" @click.stop="showRouter(goods)">
          <iProductDetail :product="_itemToGoods(goods)" />
        </div>
      </div>
      <!-- <div class="list-item" v-for="(item, index) in dataList" :key="item.Id">
        <product-list-item :ref="'p_'+item.Id" :product="item" fromPage="ActivityArea" :style="{marginLeft:index % 4 == 0 ?'0px':'20px'}"
          @showProduct="()=>{showRouter(item)}" goods-type="VGoods" />
      </div> -->
      <iPagination :currentPage.sync="formData.pageindex" :limit.sync="formData.pagesize" :totalCount="formData.totalCount" @turn="onLoad"
        style="width:1200px" v-if="dataList&&dataList.length" />
      <EmptyControl style="width:1200px;margin:20px 0 ;padding: 100px 0;" v-if="!dataList.length && !loading" type="goods" text="没有找到商品哦~">
      </EmptyControl>
    </div>
    <iFooter />
  </div>
</template>

<script>
  import iHeader from "@/components/Header";
  import iNav from "@/components/Nav";
  import iClassify from "@/components/Classify";
  import iPageTitle from "@/components/PageTitle";
  import iFooter from "@/components/Footer";
  import iRightFixedBox from "@/components/RightFixedBox";
  import ProductListItem from "@/components/ProductListItem";
  import iProductDetail from "@/components/ProductDetail";
  import { BaseMixin } from "../../mixins/BaseMixin";
  import { CollectType } from "@/dictionary/goods.js";
  import iPagination from "@/components/iPagination";

  export default {
    mixins: [BaseMixin],
    components: {
      iHeader,
      iNav,
      iFooter,
      iRightFixedBox,
      iClassify,
      iPageTitle,
      ProductListItem,
      iPagination,
      iProductDetail
    },
    data() {
      return {
        pageTitle: ["满赠专区"],
        dataList: [],
        dataIdList: [],
        loading: true,
        //请求参数
        formData: {
          pageindex: 1,
          pagesize: 10,
          totalCount: 0,
          isHasActivity: true,
          keyword: ''
        },
        url: {
          getNewGoodsList: "/api_goods/GoodsSku/ListForCustomer" //活动专区列表
        }
      };
    },
    mounted() {
      this.onLoad();
    },
    methods: {
      showRouter: function (item) {
        this._jump(this.Enum_LinkTypeCode.ProductDetails, item.Id, "_blank");
      },

      //加载数据
      async loadData() {
        // 加载状态
        this.$hys.openLoading();
        var params = Object.assign(
          {
            pageindex: this.formData.pageindex,
            pagesize: this.formData.pagesize
          },
          this.formData
        );
        let pros = await this.getAction(`${this.url.getNewGoodsList}`, params);
        this.$hys.clearLoading();
        if (pros.IsSuccess) {
          this.dataList = [];
          this.dataIdList = [];
          //数据处理

          this.formData.totalCount = pros.Count;
          pros.Data.forEach(item => {
            item.img = this._showProductPicture(item.Logo);
            item.name = this._showProductTitle(item.SkuName, item.OperationName);
            // item.Specifications = item.SpecificationsName;
            item.subId = null;
            this.dataList.push(item);
            this.dataIdList.push(item.Id);
          });
        } else {
          this.$toast({ position: "bottom", message: res.Msg });
        }
        this.loading = false;
      },
      //加载数据
      async onLoad() {
        await this.loadData();
      }
    }
  };
</script>

<style lang="less" scoped>
  .list {
    margin: auto;
    margin-bottom: 20px;
    width: 1200px;
    max-width: 1200px;
    min-height: 500px;

    .list-item {
      float: left;
      text-align: center;
      padding-top: 20px;
    }
    .goods-item{
      width: 20%;
      cursor: pointer;
      padding: 10px;
    }
    .goods-box{
      margin: 0 -10px;
      display: flex;
      flex-wrap: wrap;
      padding-top: 10px;
    }
  }

  .searchBox {
    width: 1200px;
    margin: 0 auto;
    margin-top: 20px;

    /deep/.van-cell {
      padding: 0;
      width: 400px;
      height: 40px;
      border-radius: 2px;
      border: 2px solid rgba(15, 110, 233, 1);
      margin-right: 50px;
      padding-left: 20px;

      &::after {
        border: 0;
      }

      .van-button {
        width: 100px;
        height: 40px;
        background: rgba(15, 110, 233, 1);
        border: 0;
        font-size: 18px;
        color: rgba(255, 255, 255, 1);
      }
    }

    .search-text {
      padding-right: 50px;
      margin-top: 10px;

      ul li {
        display: inline-block;
        margin-right: 10px;

        >span {
          border-right: 1px solid #e5e5e5;
          padding-right: 10px;
          cursor: pointer;
        }

        &:last-child {
          margin-right: 0;

          >span {
            border-right: 0;
            padding-right: 0;
          }
        }
      }
    }
  }
</style>